import {
  requiredString,
  optionalString,
  optionalUrl,
  optionalFile,
  createResourceSchema
} from './common'

export const sponsorSchema = createResourceSchema({
  name: requiredString('Name'),
  url: optionalUrl,
  short_description: optionalString,
  logo: optionalFile
})
